<script setup lang="ts">
//#region imports
import {computed} from 'vue';
import _ from '@/setup/lodash';
//#endregion

//#region types
interface Props {
  name?: string,
  size?: number | string,
  color?: string,
  substyle?: string,
  cursor?: boolean,
  disabled?: boolean,
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  name: '',
  size: 12,
  color: '#4c525c',
  substyle: 'fas',
  cursor: false,
  disabled: false,
});

const emit = defineEmits(['click']);
//#endregion

//#region computed
const fontClass = computed(() => {
  return `${props.substyle} fa fa-${props.name}`;
});

const iconStyle = computed(() => {
  const size = _.isFinite(props.size)
    ? `${props.size}px`
    : _.toString(props.size);
  return {
    color: props.color || '#4c525c',
    fontSize: size,
  };
});
//#endregion
</script>

<template>
  <i
    :class="[
      'ui-icon',
      fontClass,
      {
        'ui-icon_pointer': cursor,
        'ui-icon_disabled': disabled
      }
    ]"
    :style="iconStyle"
    @click="emit('click', $event)"
  />
</template>

<style lang="scss">
.ui-icon {
  --fa-display: flex;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: nowrap;
  outline: none;
  line-height: 1;
  font-style: normal;
  font-variant: normal;
  text-transform: none;
  user-select: none;
  box-shadow: none;
  box-sizing: border-box;
  font-family: 'Font Awesome 7 Pro' !important;

  &_pointer {
    cursor: pointer;
  }
  &_disabled {
    opacity: .5;
    cursor: not-allowed;
  }
}

@keyframes rotating {
  0% {
    transform: rotateZ(0deg);
  }
  100% {
    transform: rotateZ(360deg);
  }
}
</style>
